/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type ShockEvent,
    ShockEventFromJSON,
    ShockEventToJSON,
} from '../models/ShockEvent';
import {
    type ShockEventCreate,
    ShockEventCreateFromJSON,
    ShockEventCreateToJSON,
} from '../models/ShockEventCreate';
import {
    type ShockEventLevel,
    ShockEventLevelFromJSON,
    ShockEventLevelToJSON,
} from '../models/ShockEventLevel';
import {
    type ShockEventSortKey,
    ShockEventSortKeyFromJSON,
    ShockEventSortKeyToJSON,
} from '../models/ShockEventSortKey';
import {
    type ShockEventUpdate,
    ShockEventUpdateFromJSON,
    ShockEventUpdateToJSON,
} from '../models/ShockEventUpdate';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface ShockEventsCreateShockEventRequest {
    shockEventCreate: ShockEventCreate;
}

export interface ShockEventsExportShockEventsRequest {
    timezone: string;
    exportType: ShockEventsExportShockEventsExportType;
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    vehicleIds?: Array<string> | null;
    userIds?: Array<string> | null;
    shockLevels?: Array<ShockEventLevel> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: ShockEventSortKey;
}

export interface ShockEventsListShockEventsRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    vehicleIds?: Array<string> | null;
    userIds?: Array<string> | null;
    shockLevels?: Array<ShockEventLevel> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: ShockEventSortKey;
}

export interface ShockEventsListShockEventsMetadataRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    vehicleIds?: Array<string> | null;
    userIds?: Array<string> | null;
    shockLevels?: Array<ShockEventLevel> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: ShockEventSortKey;
}

export interface ShockEventsReadShockEventRequest {
    shockEventId: string;
}

export interface ShockEventsUpdateShockEventRequest {
    shockEventId: string;
    shockEventUpdate: ShockEventUpdate;
}

/**
 * ShockEventsApi - interface
 * 
 * @export
 * @interface ShockEventsApiInterface
 */
export interface ShockEventsApiInterface {
    /**
     * Creates request options for shockEventsCreateShockEvent without sending the request
     * @param {ShockEventCreate} shockEventCreate 
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsCreateShockEventRequestOpts(requestParameters: ShockEventsCreateShockEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new shock event
     * @summary Create a shock event.
     * @param {ShockEventCreate} shockEventCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsCreateShockEventRaw(requestParameters: ShockEventsCreateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockEvent>>;

    /**
     * Create a new shock event
     * Create a shock event.
     */
    shockEventsCreateShockEvent(requestParameters: ShockEventsCreateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockEvent>;

    /**
     * Creates request options for shockEventsExportShockEvents without sending the request
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {Array<ShockEventLevel>} [shockLevels] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockEventSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsExportShockEventsRequestOpts(requestParameters: ShockEventsExportShockEventsRequest): Promise<runtime.RequestOpts>;

    /**
     * The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * @summary Export shock events as csv or xlsx
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {Array<ShockEventLevel>} [shockLevels] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockEventSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsExportShockEventsRaw(requestParameters: ShockEventsExportShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * Export shock events as csv or xlsx
     */
    shockEventsExportShockEvents(requestParameters: ShockEventsExportShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for shockEventsListShockEvents without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {Array<ShockEventLevel>} [shockLevels] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockEventSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsListShockEventsRequestOpts(requestParameters: ShockEventsListShockEventsRequest): Promise<runtime.RequestOpts>;

    /**
     * Get a paginated view on all the shock events. The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * @summary List shock events
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {Array<ShockEventLevel>} [shockLevels] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockEventSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsListShockEventsRaw(requestParameters: ShockEventsListShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShockEvent>>>;

    /**
     * Get a paginated view on all the shock events. The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * List shock events
     */
    shockEventsListShockEvents(requestParameters: ShockEventsListShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShockEvent>>;

    /**
     * Creates request options for shockEventsListShockEventsMetadata without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {Array<ShockEventLevel>} [shockLevels] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockEventSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsListShockEventsMetadataRequestOpts(requestParameters: ShockEventsListShockEventsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Shock event listing metadata
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {Array<ShockEventLevel>} [shockLevels] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockEventSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsListShockEventsMetadataRaw(requestParameters: ShockEventsListShockEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Shock event listing metadata
     */
    shockEventsListShockEventsMetadata(requestParameters: ShockEventsListShockEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for shockEventsReadShockEvent without sending the request
     * @param {string} shockEventId 
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsReadShockEventRequestOpts(requestParameters: ShockEventsReadShockEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the shock event specified by the given ID.
     * @summary Get a single shock event
     * @param {string} shockEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsReadShockEventRaw(requestParameters: ShockEventsReadShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockEvent>>;

    /**
     * Returns the shock event specified by the given ID.
     * Get a single shock event
     */
    shockEventsReadShockEvent(requestParameters: ShockEventsReadShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockEvent>;

    /**
     * Creates request options for shockEventsUpdateShockEvent without sending the request
     * @param {string} shockEventId 
     * @param {ShockEventUpdate} shockEventUpdate 
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsUpdateShockEventRequestOpts(requestParameters: ShockEventsUpdateShockEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the shock event specified by the given ID.
     * @summary Update shock event
     * @param {string} shockEventId 
     * @param {ShockEventUpdate} shockEventUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockEventsApiInterface
     */
    shockEventsUpdateShockEventRaw(requestParameters: ShockEventsUpdateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockEvent>>;

    /**
     * Update the shock event specified by the given ID.
     * Update shock event
     */
    shockEventsUpdateShockEvent(requestParameters: ShockEventsUpdateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockEvent>;

}

/**
 * 
 */
export class ShockEventsApi extends runtime.BaseAPI implements ShockEventsApiInterface {

    /**
     * Creates request options for shockEventsCreateShockEvent without sending the request
     */
    async shockEventsCreateShockEventRequestOpts(requestParameters: ShockEventsCreateShockEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockEventCreate'] == null) {
            throw new runtime.RequiredError(
                'shockEventCreate',
                'Required parameter "shockEventCreate" was null or undefined when calling shockEventsCreateShockEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_events/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShockEventCreateToJSON(requestParameters['shockEventCreate']),
        };
    }

    /**
     * Create a new shock event
     * Create a shock event.
     */
    async shockEventsCreateShockEventRaw(requestParameters: ShockEventsCreateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockEvent>> {
        const requestOptions = await this.shockEventsCreateShockEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShockEventFromJSON(jsonValue));
    }

    /**
     * Create a new shock event
     * Create a shock event.
     */
    async shockEventsCreateShockEvent(requestParameters: ShockEventsCreateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockEvent> {
        const response = await this.shockEventsCreateShockEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockEventsExportShockEvents without sending the request
     */
    async shockEventsExportShockEventsRequestOpts(requestParameters: ShockEventsExportShockEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['timezone'] == null) {
            throw new runtime.RequiredError(
                'timezone',
                'Required parameter "timezone" was null or undefined when calling shockEventsExportShockEvents().'
            );
        }

        if (requestParameters['exportType'] == null) {
            throw new runtime.RequiredError(
                'exportType',
                'Required parameter "exportType" was null or undefined when calling shockEventsExportShockEvents().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shockEventsExportShockEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['exportType'] != null) {
            queryParameters['export_type'] = requestParameters['exportType'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['shockLevels'] != null) {
            queryParameters['shock_levels'] = requestParameters['shockLevels'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_events/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * Export shock events as csv or xlsx
     */
    async shockEventsExportShockEventsRaw(requestParameters: ShockEventsExportShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.shockEventsExportShockEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * Export shock events as csv or xlsx
     */
    async shockEventsExportShockEvents(requestParameters: ShockEventsExportShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.shockEventsExportShockEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockEventsListShockEvents without sending the request
     */
    async shockEventsListShockEventsRequestOpts(requestParameters: ShockEventsListShockEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shockEventsListShockEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['shockLevels'] != null) {
            queryParameters['shock_levels'] = requestParameters['shockLevels'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_events/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated view on all the shock events. The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * List shock events
     */
    async shockEventsListShockEventsRaw(requestParameters: ShockEventsListShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShockEvent>>> {
        const requestOptions = await this.shockEventsListShockEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShockEventFromJSON));
    }

    /**
     * Get a paginated view on all the shock events. The endpoint will return shock events that have the between `date_start` and `date_end` and also exact same value as `date_start`. `date_start <= shock_event.time < date_end`
     * List shock events
     */
    async shockEventsListShockEvents(requestParameters: ShockEventsListShockEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShockEvent>> {
        const response = await this.shockEventsListShockEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockEventsListShockEventsMetadata without sending the request
     */
    async shockEventsListShockEventsMetadataRequestOpts(requestParameters: ShockEventsListShockEventsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shockEventsListShockEventsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['shockLevels'] != null) {
            queryParameters['shock_levels'] = requestParameters['shockLevels'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_events/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Shock event listing metadata
     */
    async shockEventsListShockEventsMetadataRaw(requestParameters: ShockEventsListShockEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.shockEventsListShockEventsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Shock event listing metadata
     */
    async shockEventsListShockEventsMetadata(requestParameters: ShockEventsListShockEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.shockEventsListShockEventsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockEventsReadShockEvent without sending the request
     */
    async shockEventsReadShockEventRequestOpts(requestParameters: ShockEventsReadShockEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockEventId'] == null) {
            throw new runtime.RequiredError(
                'shockEventId',
                'Required parameter "shockEventId" was null or undefined when calling shockEventsReadShockEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_events/{shock_event_id}`;
        urlPath = urlPath.replace('{shock_event_id}', encodeURIComponent(String(requestParameters['shockEventId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the shock event specified by the given ID.
     * Get a single shock event
     */
    async shockEventsReadShockEventRaw(requestParameters: ShockEventsReadShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockEvent>> {
        const requestOptions = await this.shockEventsReadShockEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShockEventFromJSON(jsonValue));
    }

    /**
     * Returns the shock event specified by the given ID.
     * Get a single shock event
     */
    async shockEventsReadShockEvent(requestParameters: ShockEventsReadShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockEvent> {
        const response = await this.shockEventsReadShockEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockEventsUpdateShockEvent without sending the request
     */
    async shockEventsUpdateShockEventRequestOpts(requestParameters: ShockEventsUpdateShockEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockEventId'] == null) {
            throw new runtime.RequiredError(
                'shockEventId',
                'Required parameter "shockEventId" was null or undefined when calling shockEventsUpdateShockEvent().'
            );
        }

        if (requestParameters['shockEventUpdate'] == null) {
            throw new runtime.RequiredError(
                'shockEventUpdate',
                'Required parameter "shockEventUpdate" was null or undefined when calling shockEventsUpdateShockEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_events/{shock_event_id}`;
        urlPath = urlPath.replace('{shock_event_id}', encodeURIComponent(String(requestParameters['shockEventId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShockEventUpdateToJSON(requestParameters['shockEventUpdate']),
        };
    }

    /**
     * Update the shock event specified by the given ID.
     * Update shock event
     */
    async shockEventsUpdateShockEventRaw(requestParameters: ShockEventsUpdateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockEvent>> {
        const requestOptions = await this.shockEventsUpdateShockEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShockEventFromJSON(jsonValue));
    }

    /**
     * Update the shock event specified by the given ID.
     * Update shock event
     */
    async shockEventsUpdateShockEvent(requestParameters: ShockEventsUpdateShockEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockEvent> {
        const response = await this.shockEventsUpdateShockEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum ShockEventsExportShockEventsExportType {
    CSV = 'csv',
    XLSX = 'xlsx'
}
